<template>
  <div class="production-manufacturing">
    <div class="banner">
      <img src="../../../assets/img/businessScope/productionManufacturing/banner.jpg" />
      <div class="banner-text">
        <div class="container wow slideInLeft">
          <h1>{{$t("productionManufacturing.banner.bannerTitle")}}</h1>
          <p>{{$t("productionManufacturing.banner.bannerP")}}</p>
        </div>
      </div>
    </div>
    <div class="container">

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('productionManufacturing.table.fushun')" name="first">
          <div class="factory">
            <div class="headline">
              <h1>{{$t("productionManufacturing.FS.factory.headlineTitle")}}</h1>
              <p>{{$t("productionManufacturing.FS.factory.headlineP")}}</p>
            </div>
            
            <div class="des">
              <p >{{$t("productionManufacturing.FS.factory.des")}}</p>
              <a href="https://www.fsltxcl.cn/" target="_blank">{{$t("productionManufacturing.FS.factory.factoryBox.link")}}</a>
            </div>

            <div class="factory-box">
              <img src="../../../assets/img/businessScope/productionManufacturing/fslt.jpg" alt="">
              <div class="factory-box-des">
                <h2>{{$t("productionManufacturing.FS.factory.factoryBox.title")}}</h2>
                <p class="small-title">{{$t("productionManufacturing.FS.factory.factoryBox.smallTitle")}}</p>
                <p>{{$t("productionManufacturing.FS.factory.factoryBox.des")}}</p>
                <p class="tr">____</p>
              </div>
            </div>
          </div>
          <div class="manufacturing-strength">
            <div class="headline">
              <h1>{{$t("productionManufacturing.FS.manufacturingStrength.headlineTitle")}}</h1>
              <p>{{$t("productionManufacturing.FS.manufacturingStrength.headlineP")}}</p>
            </div>
            <el-row :gutter="30">
                <el-col :span="8" :xs="24" v-for="(item,index) in $t('productionManufacturing.FS.manufacturingStrength.lists')" :key="index">
                  <div class="pic-wrap">
                    <div class="des-box">
                        <el-popover
                          placement="bottom-start"
                          width="300"
                          :title="item.title"
                          trigger="hover"
                          >
                          <div>
                            <p>{{item.des}}</p>
                            <p style="font-weight:bold;color:#666">{{item.des2}}</p>
                          </div>
                          <div slot="reference">
                            <h2>{{item.title}}</h2>
                            <p>{{item.des}}</p>
                            <p style="font-weight:bold;color:#666">{{item.des2}}</p>
                          </div>
                        </el-popover>
                    </div>
                    <div class="pic">
                        <img :src="item.picUrl" />
                    </div>
                  </div>
                </el-col>
            </el-row>
          </div>
          <div class="main-product">
            <div class="headline">
              <h1>{{$t("productionManufacturing.FS.mainProduct.headlineTitle")}}</h1>
              <p>{{$t("productionManufacturing.FS.mainProduct.headlineP")}}</p>
            </div>
            <el-row :gutter="30">
                <el-col :span="8" :xs="24" v-for="(item,index) in $t('productionManufacturing.FS.mainProduct.lists')" :key="index">
                  <div class="pic-wrap">
                    <div class="pic">
                        <img :src="item.picUrl" />
                    </div>
                    <div class="des-box">
                      <el-popover
                        placement="top-start"
                        width="300"
                        :title="item.title"
                        trigger="hover"
                        :content="item.des">
                        <div slot="reference">
                          <h2>{{item.title}}</h2>
                          <p>{{item.des}}</p>
                        </div>
                      </el-popover>
                    </div>
                  </div>
                </el-col>
            </el-row>
          </div>
          <div class="quality-assurance">
            <div class="headline">
              <h1>{{$t("productionManufacturing.FS.qualityAssurance.headlineTitle")}}</h1>
              <p>{{$t("productionManufacturing.FS.qualityAssurance.headlineP")}}</p>
            </div>
            <el-row :gutter="40">
                <el-col :span="8"  :xs="24" v-for="(item,index) in $t('productionManufacturing.FS.qualityAssurance.lists')" :key="index">
                  <div class="pic-wrap">
                    <img :src="item.picUrl" class="pic"/>
                    <div class="des-box">
                      <h3>{{item.title}}</h3>
                    </div>
                  </div>
                </el-col>
            </el-row>
          </div>
          <div class="honor">
            <div class="headline">
              <h1>{{$t("productionManufacturing.FS.honorAndAualification.headlineTitle")}}</h1>
              <p>{{$t("productionManufacturing.FS.honorAndAualification.headlineP")}}</p>
            </div>
            <!-- <el-carousel :autoplay="false" arrow="always" :height="imgH+'px'" >
              <el-carousel-item v-for="item in $t('productionManufacturing.FS.honorAndAualification.list').length/4" :key="item">
                <el-row :gutter="40">
                    <el-col :span="6" v-for="(item,index) in $t('productionManufacturing.FS.honorAndAualification.list').slice(item*4-4,item*4)" :key="index">
                        <img :src="item.picUrl" class="pic"  ref="honorPic" @contextmenu="hideContextMenu"/>
                    </el-col>
                </el-row>
              </el-carousel-item>
            </el-carousel> -->
            <el-row :gutter="40">
                <el-col :span="6"  :xs="12" v-for="(item,index) in $t('productionManufacturing.FS.honorAndAualification.list')" :key="index">
                    <img :src="item.picUrl" class="pic"  ref="honorPic" @contextmenu="hideContextMenu"/>
                </el-col>
            </el-row>
          </div>
          <div class="school">
            <div class="headline">
              <h1>{{$t("productionManufacturing.FS.schoolEnterpriseCooperation.headlineTitle")}}</h1>
              <p>{{$t("productionManufacturing.FS.schoolEnterpriseCooperation.headlineP")}}</p>
            </div>
            <div class="school-box">
              <el-row :gutter="40">
                <el-col :span="8"  :xs="24">
                  <div class="des" v-html="$t('productionManufacturing.FS.schoolEnterpriseCooperation.des')"></div>
                </el-col>
                <el-col :span="8"  :xs="24">
                  <img src="../../../assets/img/businessScope/productionManufacturing/school.png" />
                </el-col>
                <el-col :span="8"  :xs="24">
                  <ul class="list">
                    <li><img src="../../../assets/img/businessScope/productionManufacturing/dbdx.png" /></li>
                    <li><img src="../../../assets/img/businessScope/productionManufacturing/sydx.png" /></li>
                    <li>{{$t('productionManufacturing.FS.schoolEnterpriseCooperation.tip')}}</li>
                  </ul>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('productionManufacturing.table.lv')" name="second" >
          <div class="factory">
            <div class="headline">
              <h1>{{$t("productionManufacturing.AL.factory.headlineTitle")}}</h1>
              <p>{{$t("productionManufacturing.AL.factory.headlineP")}}</p>
            </div>
            <p class="des">{{$t("productionManufacturing.AL.factory.des")}}</p>

            <div class="factory-box">
              <img src="../../../assets/img/businessScope/productionManufacturing/al/factory.jpg" alt="">
              <div class="factory-box-des">
                <h2>{{$t("productionManufacturing.AL.factory.factoryBox.title")}}</h2>
                <p class="small-title">{{$t("productionManufacturing.AL.factory.factoryBox.smallTitle")}}</p>
                <p>{{$t("productionManufacturing.AL.factory.factoryBox.des")}}</p>
                <p class="tr">____</p>
              </div>
            </div>
          </div>
          <div class="manufacturing-strength">
            <div class="headline">
              <h1>{{$t("productionManufacturing.AL.manufacturingStrength.headlineTitle")}}</h1>
              <p>{{$t("productionManufacturing.AL.manufacturingStrength.headlineP")}}</p>
            </div>
            <el-row :gutter="30">
                <el-col :span="6" :xs="24" v-for="(item,index) in $t('productionManufacturing.AL.manufacturingStrength.lists')" :key="index">
                  <div class="pic-wrap">
                    <div class="des-box">
                        <el-popover
                          placement="bottom-start"
                          width="300"
                          :title="item.title"
                          trigger="hover"
                          :content="item.des">
                          <div slot="reference">
                            <h2>{{item.title}}</h2>
                            <p>{{item.des}}</p>
                          </div>
                        </el-popover>
                    </div>
                    <div class="pic">
                        <img :src="item.picUrl" />
                    </div>
                  </div>
                </el-col>
            </el-row>
          </div>
          <div class="main-product al">
            <div class="headline">
              <h1>{{$t("productionManufacturing.AL.mainProduct.headlineTitle")}}</h1>
              <p>{{$t("productionManufacturing.AL.mainProduct.headlineP")}}</p>
            </div>
            <el-row :gutter="30">
                <el-col :span="8" :xs="24" v-for="(item,index) in $t('productionManufacturing.AL.mainProduct.lists')" :key="index">
                  <div class="pic-wrap">
                    <div class="pic" ref="mainPic" :style="{height:mainPicH+'px'}">
                        <img :src="item.picUrl" />
                    </div>
                    <div class="des-box">
                        <h2>{{item.title}}</h2>
                        <div v-html="item.des"></div>
                    </div>
                  </div>
                </el-col>
            </el-row>
          </div>
          <div class="quality-assurance">
            <div class="headline">
              <h1>{{$t("productionManufacturing.AL.qualityAssurance.headlineTitle")}}</h1>
              <p>{{$t("productionManufacturing.AL.qualityAssurance.headlineP")}}</p>
            </div>
            <el-row :gutter="40">
                <el-col :span="6"  :xs="24" v-for="(item,index) in $t('productionManufacturing.AL.qualityAssurance.lists')" :key="index">
                  <div class="pic-wrap">
                    <img :src="item.picUrl" class="pic"/>
                    <div class="des-box">
                      <h3>{{item.title}}</h3>
                    </div>
                  </div>
                </el-col>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>

    </div>

  </div>
</template>

<script>
export default {
  name: "ProductionManufacturing",
  data() {
    return {
      activeName: 'first',
      imgH:'',
      mainPicH:''
    };
  },
  mounted() {
    
    var options = { live: false };
    new this.$wow.WOW(options).init();
    this.$nextTick(()=>{
      setTimeout(()=>{
        this.imgH = this.$refs.honorPic[0].offsetHeight;
        console.log(this.imgH)
      },2000) 
    })
    
  },
  methods: {
    handleClick(tab, event) {
     if(tab.index=="1"){
      this.$nextTick(()=>{

          this.mainPicH = this.$refs.mainPic[0].offsetWidth;
          console.log(this.mainPicH)

      })
     }

    },
    hideContextMenu(event) {
      // 阻止默认右键菜单
    //  event.preventDefault();
      event.returnValue=false
    },

  }
};
</script>

<style scoped lang="scss">
$cblue: #0054A7;
.production-manufacturing{
  
  ::v-deep .el-tabs__header{
    margin-top:30px;
    margin-bottom:0;
    .el-tabs__nav-wrap::after{
      height:0;
    }
    .el-tabs__item{
      font-size:18px;
    }
  }
  .factory{
    .des{
      width:800px;
      margin:0 auto;
      text-align: justify;
      margin-bottom:80px;

      a{
        color:$cblue;
        font-weight: bold;
        font-size: 20px;
        &:hover{
          text-decoration: underline;
        }
      }
    }
    .factory-box{
      position: relative;
      padding:50px 0;
      img{
        width:74%;
      }
      .factory-box-des{
        position: absolute;
        right:0;
        top:0;
        width:36%;
        height:100%;
        background:$cblue;
        color:#fff;
        padding:40px;
        box-sizing: border-box;
        text-align: justify;
        .small-title{
          font-size: 22px;
          margin:10px 0;
          font-weight: bold;
        }
        .tr{
          position: absolute;
          right:40px;
          bottom:40px;
          font-weight: bold;
        }
      }
    }
  }
  .manufacturing-strength{
    .pic-wrap{
      // margin-bottom:60px;
      .pic{
          img{
            width:100%;
            height:300px;
            object-fit: cover;
          }
      }
      .des-box{
        box-sizing: border-box;
        height: 300px;
        background: #F4F4F4;
        padding:30px;
        border-radius: 15px 15px 0 0;
        h2{
          margin-bottom:20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        p{
          color: #888888;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 6;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .main-product{
    .pic-wrap{
      margin-bottom:60px;
      .pic{
          img{
            width:100%;
          }
      }
      .des-box{
        box-sizing: border-box;
        // height: 200px;
        padding:30px;
        border-radius: 0 0 15px 15px;
        border:1px solid #ddd;

        h2{
          margin-bottom:10px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        p{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .main-product.al{
    .pic-wrap{
      margin-bottom:60px;
      .pic{
          padding:20px;
          background: #F4F4F4;
          border-radius: 22px 22px 0px 0px;
          box-sizing: border-box;
          border:1px solid #ddd;
          border-bottom:none;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            max-width: 80%;
            max-height: 80%;
            object-fit: contain;
          }
      }

    }
  }

  .quality-assurance{
    .pic-wrap{
      position: relative;
      overflow: hidden;
      margin-bottom:30px;
      img.pic{
        width:100%;
        height:400px;
        object-fit: cover;
        border-radius: 10px;
      }
      .des-box{
        position: absolute;
        left:0;
        top:100%;
        width: 100%;
        padding:10px;
        background:rgba($color: #000000, $alpha: 0.5);
        box-sizing: border-box;
        text-align: center;
        transition: all 0.4s;
        color:#fff;
      }
      &:hover{
        .des-box{
          transform: translateY(-100%);
        }
      }
    }
  }
  .honor{
    img{
      width:100%;
      -moz-user-select: none; 
      -webkit-user-select: none; 
      -ms-user-select: none; 
      -khtml-user-select: none; 
      user-select: none;
      margin-bottom:20px;
    }
  }
  .school{
    font-size: 18px;
    .school-box{
      width:80%;
      margin:0 auto;
      .des{
        color:#000;
        margin-top:50%;
        transform: translateY(-50%);
        font-weight: bold;
      }
      .list{
        li{
          background: #F3F3F3;
          height:120px;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          &+li{
            margin-top:10px
          }
        }
      }
    }
  }
  @media screen and (max-width:768px){
    .factory{
      .des{
        width:100%;
        margin-bottom:40px;
        a{
          text-decoration: underline;
        }
      }
      .factory-box{
        position: relative;
        padding:0;
        img{
          width:100%;
          margin-bottom:20px;
        }
        .factory-box-des{
          position: relative;
          right:0;
          top:0;
          width:100%;
          height:auto;
          background:$cblue;
          color:#fff;
          padding:20px;
          box-sizing: border-box;
          text-align: left;
          h2{
            text-align: left;
          }
          .tr{
            position: absolute;
            right:20px;
            bottom:20px;
            font-weight: bold;
          }
        }
      }
    }
    .manufacturing-strength{
      .pic-wrap{
        margin-bottom:20px;
        .pic{
            img{
              width:100%;
              height:auto;
              object-fit: cover;
            }
        }
        .des-box{
          box-sizing: border-box;
          height: auto;
          background: #F4F4F4;
          padding:15px;
          border-radius: 15px 15px 0 0;
          h2{
            display: block;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: none;
            overflow:visible;
            text-overflow: clip;
          }
          p{
            display: block;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: none;
            overflow: visible;
            text-overflow: clip;
          }
        }
      }
    }
    .main-product{
      .pic-wrap{
        margin-bottom:30px;
        .des-box{
          box-sizing: border-box;
          padding:30px;
          border-radius: 0 0 15px 15px;
          border:1px solid #ddd;
          h2{
            margin-bottom:10px;
            display: block;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: none;
            overflow:visible;
            text-overflow: clip;
          }
          p{
            display: block;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: none;
            overflow: visible;
            text-overflow: clip;
          }
        }
      }
    }
    .quality-assurance{
      .pic-wrap{
        position: relative;
        overflow: hidden;
        margin-bottom:20px;
        img.pic{
          width:100%;
        }
        .des-box{
          position: absolute;
          left:0;
          top:100%;
          width: 100%;
          padding:10px;
          background:rgba($color: #000000, $alpha: 0.5);
          box-sizing: border-box;
          text-align: center;
          transition: all 0.4s;
          color:#fff;
          transform: translateY(-100%);
        }
        
      }
    }
    .school{
      font-size: 18px;
      .school-box{
        width:80%;
        margin:0 auto;
        .des{
          color:#000;
          margin-top:0;
          transform: translateY(0);
          font-weight: bold;
        }
        
      }
    }
  }
}
</style>
